import { useCallback } from 'react';
import { useQuery } from 'react-query';
import type { UseQueryResult } from 'react-query';
import { moment } from '@hotjar/webapp/lib/moment';
import { getBeamerPosts } from './api';
import type { RawBeamerPost, BeamerPost } from './types';

const BEAMER_QUERY_KEY = 'beamer_posts';

export const useGetBeamerPosts = (
  language: string,
  enabled = false,
): UseQueryResult<BeamerPost[], Error> => {
  return useQuery({
    enabled,
    select: useCallback(
      (posts) => {
        return posts.reduce((allPosts: RawBeamerPost[], currentPost: RawBeamerPost) => {
          if (
            currentPost.translations.find((post) => post.language.toLocaleLowerCase() === language)
          ) {
            const { translations, date, ...postWithoutTranslations } = currentPost;
            const formattedDate = moment(date).format('ll');

            return [
              ...allPosts,
              {
                ...postWithoutTranslations,
                ...translations.find((post) => post.language.toLocaleLowerCase() === language),
                date: formattedDate,
              },
            ];
          }

          return allPosts;
        }, []);
      },
      [language],
    ),
    queryKey: [BEAMER_QUERY_KEY],
    refetchOnWindowFocus: false,
    staleTime: 60 * 60 * 1000,
    queryFn: async () => {
      if (!enabled) throw new Error();

      return getBeamerPosts();
    },
  });
};
